import React from 'react'
import Typography from '@material-ui/core/Typography';

const ContactUs = () => (
  <Typography component="h1" variant="h4">Contact Us</Typography>
)

export default ContactUs;
